import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Portals } from '@qwyk/models';
import { Observable } from 'rxjs';
import { CustomFieldsEntity } from './+state/custom-fields.models';
import { environment } from '@qwyk/portals/environment';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class CustomFieldsService {
    constructor(private http: HttpClient) {}

    public getCustomFields(
        parent: Portals.ParentEntity,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
        query: any
    ): Observable<CustomFieldsEntity[]> {
        return this.http
            .get<{ data: CustomFieldsEntity[] }>(
                `${environment.backendServer}/api/portals/${parent.domain}/${parent.type}/${parent.id}/custom-fields`
            )
            .pipe(
                take(1),
                map(response => response.data)
            );
    }
}
